import { BlocksIconChevronRight } from 'blocks-nextjs/blocks-web-components/components/icon/icons/chevron-right';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconChevronRight = createComponent({ react: React, tagName: 'cat-icon-chevron-right', elementClass: BlocksIconChevronRight });
